import axios from 'axios'

const token = localStorage.getItem('jwt')
let url = 'http://localhost:3030/api/'

if (window.location.hostname.indexOf('localhost') === -1) {
  url = window.location.protocol + '//' + window.location.host + '/api/'
}

const http = axios.create({
  baseURL: url
})

if (token) {
  http.defaults.headers.common['Authorization'] = token
}

export default http
